<template>
<div>
    <el-alert v-if="isAdd" title="达人未入驻" type="error" center show-icon></el-alert>
    <contenr/>
    <div class="darenInfoContainer clear">
        <div class="contentLeft">
            <DetailPanel v-loading="loadingObj.darenInfo" :viewType.sync="viewType" :authorDrinfo="authorDrinfo" :darenInfo="darenInfo" :otherInfo="otherInfo" @showCalendarDia="showCalendarDia" @hadBlack="hadBlack"></DetailPanel>
        </div>
        <div class="contentRight" >
            <el-tabs v-if="viewType == '短视频主页'" v-model="activeName" class="tab-block-wrap" >
                <el-tab-pane label="达人概览" name="达人概览"><Outline @scrollToTab2Video="scrollToTab2Video" :darenInfo="darenInfo" :authorDrinfo="authorDrinfo" :hideSupplierTable="true" :supplierList="supplierList"  v-if="activeName==='达人概览'"></Outline></el-tab-pane>
                <!-- <el-tab-pane label="合作案例" name="合作案例" v-if="$store.state.auth.showCooperAnalysis == 1 && auth_order_type.length"><Cooperation2 v-if="activeName==='合作案例'" :viewType="viewType" :hideCooperationDetailTable="true"></Cooperation2></el-tab-pane> -->
                <el-tab-pane label="内容表现" name="内容表现" v-if="$route.query.id"><Expression v-if="activeName==='内容表现'"></Expression></el-tab-pane>
                <el-tab-pane label="连接用户" name="连接用户" v-if="$route.query.id"><Analysis v-if="activeName==='连接用户'" ></Analysis></el-tab-pane>
                <el-tab-pane label="商业能力" name="商业能力" v-if="$route.query.id"><Capabilities v-if="activeName==='商业能力'"></Capabilities></el-tab-pane>
                <!-- <el-tab-pane label="传播表现" name="传播表现"><Expression v-if="activeName==='传播表现'"></Expression></el-tab-pane> -->
                <!-- <el-tab-pane label="受众分析" name="连接用户"><Analysis v-if="activeName==='连接用户'"></Analysis></el-tab-pane> -->
                <!-- <el-tab-pane label="游戏转化" name="游戏转化"><Game v-if="activeName==='游戏转化'"></Game></el-tab-pane> -->
                <!-- <el-tab-pane label="电商带货" name="电商带货"><Goods v-if="activeName==='电商带货'"></Goods></el-tab-pane> -->
                <!-- <el-tab-pane label="星图案例" name="星图案例" v-if="$store.state.auth.showCooperAnalysis == 1 || true"><Example v-if="activeName==='星图案例'"></Example></el-tab-pane> -->
                <!-- <el-tab-pane label="合作案例" name="合作案例" v-if="$store.state.auth.showCooperAnalysis == 1 || true"><Cooperation v-if="activeName==='合作案例'"></Cooperation></el-tab-pane> -->
            </el-tabs>
            <el-tabs v-else-if="viewType == '直播主页'" v-model="liveActiveName" class="tab-block-wrap" >
              <el-tab-pane lazy label="数据概览" name="数据概览"><LiveOverview v-if="liveActiveName == '数据概览'"  :searchForm="liveSearchForm" :supplierList="supplierList" /></el-tab-pane>
              <!-- <el-tab-pane lazy label="合作案例" name="合作案例" v-if="$store.state.auth.showCooperAnalysis == 1 && auth_order_type.length" ><Cooperation2 v-if="liveActiveName == '合作案例'"  :searchForm="liveSearchForm" :viewType="viewType" /></el-tab-pane> -->
              <el-tab-pane lazy label="直播分析" name="直播分析"><LiveAnalysis v-if="liveActiveName == '直播分析'"  :searchForm="liveSearchForm" /></el-tab-pane>
              <el-tab-pane lazy label="受众画像" name="受众画像"><LiveAudienceProfile  v-if="liveActiveName == '受众画像'" :searchForm="liveSearchForm" /></el-tab-pane>
            </el-tabs>
        </div>
    </div>

    <Calendar :outerDiaVisible.sync="outerDiaVisible" :info="calendarInfo"></Calendar>
  </div>
</template>
<script>
import Cooperation2 from "./Cooperation/Cooperation2.vue";
import Outline from "./Outline/Outline.vue";
import Analysis from "./Analysis/Analysis.vue";
import Expression from "./Expression/Expression.vue";
import contenr from "../content"
import Capabilities from './Capabilities/Capabilities.vue';


// import Goods from "./Goods/Goods.vue";
// import Cooperation from "./Cooperation/Cooperation.vue";
// import Game from "./Game/Game.vue";
// import Example from "./Example/Example.vue";
// import Clipboard from 'clipboard'
// import CryptoJS from 'crypto-js';

export default {
  name: "daren",
  props:[],
  data(){
    return {
        viewType: '短视频主页', //页面类型 '短视频主页'，'直播主页'
        activeName: '达人概览',//当前tab  达人概览
        liveActiveName: '数据概览',
        liveSearchForm: {  //用于直播主页各tab在created时赋搜索的默认值(各tab间共享搜索条件)
          liveType: 1,
          onlyStarOrder: 0,
          period: 30,
        },
        //达人基础信息
        darenID:'',
        darenInfo:{},
        darenDes:{},
        // 达人报价信息
        darenPrice:{},

        isAdd:false,

        authorDrinfo:{},
        isChangwanDaren:false,
        favoriteList: [],
        hasInStorage: false,
        outerDiaVisible: false,
        calendarInfo: {},

        auth_order_type: [],
        linkStruct:{},
        allStruct:0,
        deepStruct:0,

        hide_fields: [],
        crmTalentInfo: {},

        is_product: false,
        checkControl:null,
        loadingObj: {
            darenInfo: false
        },

        // 合作号/野生 的供应商信息,在左侧面板和达人概览tab下会用到
        supplierList:[]
    }
  },
  components:{
    // Cooperation,
    Outline,
    Expression,
    Analysis,
    // Goods,
    // Example,
    // Game,
    contenr,
    Cooperation2,
    Calendar: () => import("@/components/calendar/calendar.vue"),
    Capabilities,
    DetailPanel: () => import("./components/DetailPanel.vue"),
    // 直播主页相关
    LiveOverview: ()=> import('./components/LiveOverview.vue'),
    LiveAudienceProfile: ()=> import('./components/LiveAudienceProfile.vue'),
    LiveAnalysis: ()=> import('./components/LiveAnalysis.vue'),
    // 直播主页相关 end
  },
  computed:{
    // 签约状态
    signStatus(){
        const today = this.dayjs().format("YYYY-MM-DD")
        const last_contract = this.crmTalentInfo.last_contract
        if (!last_contract) {
            return '-'
        } else if (today>last_contract.due_dt){
            return '已过期'
        } else if (today>=last_contract.sign_dt&&today<= last_contract.due_dt){
            return '已签约'
        } else {
            return '-'
        }
    },
    otherInfo(){
        return {
            mid: this.crmTalentInfo.id, // 媒体库id
            supplierList: this.supplierList,  //供应商信息
            checkControl: this.checkControl, //警告提示

            specialSaletype: this.crmTalentInfo.special_saletype, //特殊售卖类型
            specialSaledesc: this.crmTalentInfo.special_saledesc, //特殊售卖描述
            allStruct: this.allStruct? this.allStruct + 'w' : '-' , //月连接用户数
            deepStruct: this.deepStruct ? this.deepStruct + 'w' : '-',    // 月深度用户数

            introduction: this.darenDes.self_intro || '',  //达人介绍
            industryTags: this.darenPrice?.industry_tags ? [...this.darenPrice?.industry_tags ] : [],  //行业标签
            changwanTags: this.authorDrinfo?.segment_labels?.split(',') || [],// 畅玩细分标签
            lastVideoTime: this.crmTalentInfo.last_video_time || '-', //最新发布时间
            mcn: this.crmTalentInfo.mcn || '-', //mcn机构

            star: this.crmTalentInfo.star || '', // 星图机构
            defaultCompanyName: this.crmTalentInfo.default_company_name || '', //机构主体

            signStatus: this.signStatus, //签约状态
            lastContractStr: this.crmTalentInfo?.last_contract ? this.crmTalentInfo?.last_contract?.sign_dt + '至' + this.crmTalentInfo?.last_contract?.due_dt : '', // 签约有效期

            darenPrice: this.darenPrice
        }

    },
    logings() {
        const logings = this.$route.query.logings || ''
        if (['合作号', '野生'].includes(logings)) {
            return '合作号/野生'
        } else {
            return logings
        }
    },
  },
  methods:{
    hadBlack(val){
      if(val){
            let blackType = '曾被纳入畅玩达人黑名单'
            this.$alert(`
            <div style="display: flex; align-items: center">
                <i class="el-icon-warning" style="font-size: 50px; color: #FF6F28;margin-right: 10px"></i>
                <div>
                    <p>${blackType}，拉黑理由：</p>
                    <p style="font-weight: 600; color: #FF6F28;">${this.authorDrinfo?.history_black_data?.black_reasons || '-'}</p>
                </div>
            </div>
            `, '提示', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '我知道了'
            });
      }
    },
    async getLinkStruct(){
        this.$api.getData.getLinkStruct(`/${this.darenID}?platform_channel=1&industry_tag=0`, false).then((res) =>{
            this.linkStruct = res.data.data
            this.allStruct = this.fmt(this.linkStruct?.link_struct?.['5']?.value, {micrometer: true, fixedUnit: '万'})
            this.deepStruct = this.fmt(this.linkStruct?.link_struct?.['5']?.value-this.linkStruct?.link_struct?.['1']?.value, {micrometer: true, fixedUnit: '万'})

        })
    },
    updateFavoriteTotal(action){
      let total = localStorage.getItem('favoriteTotal')
      if(action === 'add'){
        total++
      }
      if(action === 'subtract'){
        total--
      }
      localStorage.setItem('favoriteTotal', total)
      this.$store.commit('FAVORITETOTAL', total)
    },
    updateFavorite(arr, action){
      let beforeList = localStorage.getItem('favoriteList')
      beforeList = beforeList ? JSON.parse(beforeList) : []
      if (typeof arr === 'object') {
        let list = [...beforeList, ...arr]
        list = Array.from(new Set(list))
        beforeList = list
      } else {
        let index = beforeList.findIndex(x => x == arr)
        if (index === -1) {
          beforeList.push(arr)
        } else {
          beforeList.splice(index, 1)
        }
      }
      localStorage.setItem('favoriteList', JSON.stringify(beforeList))
      this.favoriteList = beforeList
      this.updateFavoriteTotal(action)
      opener.parentPageMethods.updateFavorite([])
    },
    addFavorite(){
      if(this.favoriteList.includes(this.darenID)){
        this.removeFavorites()
      }else{
        let {mcn = '', id = '', nick_name = '', avatar_uri = '', follower = 0} = this.darenInfo
        let tags = []
        let logings = this.$route.query.logings || ''
        if(mcn === '畅玩文化' || mcn.includes('畅玩达人')){
          tags.push('畅玩达人')
        }
        logings && tags.push(logings)
        let params ={
          id,
          nick_name,
          avatar_uri,
          follower,
          tags: tags.join()
        }
        this.$axios.post('/author-addcoll', params).then(res => {
          if(res?.data?.code === 0){
            this.updateFavorite(id, 'add')
            this.$message.success('添加成功')
          }
        })
      }
    },
    removeFavorites() {
      let params = {
        id: this.darenID
      }
      this.$axios.get('/author-delcoll', {params}).then(res => {
        if(res?.data?.code === 0){
          this.updateFavorite(this.darenID, 'subtract')
          this.$message.success('取消成功')
        }
      })
    },
    checkControlFn() {
      this.$api.getData.checkControl(`/${this.darenID}`).then(res => {
        if(res?.data?.code === 0){
            this.checkControl = res?.data?.data?.control_status?.[this.darenID]?.status
        }
      })
    },
    addToLb(){
      let loading = this.$loading({
        lock: true,
        text: '入库中，请稍后...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let starid = this.$route.query.id
      this.$axios.post('/api.php?a=addLibrary&m=gx', {
        platid: 1,
        starid
      }).then(res => {
        this.hasInStorage = true
        opener?.parentPageMethods?.updateIfInStorage?.(starid)
        this.$message.success('入库成功')
      }).finally(() => {
        loading.close()
      })
    },
    showCalendarDia() {
        this.outerDiaVisible = true
    },

    scrollToTab2Video(){
      this.$nextTick(() => {
        // this.$refs.tabB.$el.scrollIntoView();
        this.activeName ='内容表现'
        setTimeout(()=>{
          const element = document.getElementById('expression-video-wrap')
          if (element) {
            element.scrollIntoView();
          }
        }, 500)

      });
    },
    async getSupplierData(id) {
        this.$axios.get('/api.php?m=index|api|gx&a=getProductlogings', { params:{ mid: id }}).then(resdata => {
            this.supplierList = resdata
        })
    },
    async getPriceData(){
      // 获取达人报价信息
      this.$api.getData.getDarenPrice(`/${this.darenID}?platform_channel=${this.viewType == '短视频主页'? 1 : 10}`, false).then((res) => {
          let price_info = res.data.data?.price_info?.map(item=>{
            if(item.desc == "21-60s视频"){
              item.desc = "植入视频"
            } else if (item.desc == "60s以上视频") {
              item.desc = "定制视频"
            }
            return item
          })?.filter(item => {
              if(this.viewType == '短视频主页'){
                return ["植入视频","定制视频","抖音短视频共创-主投稿达人","抖音短视频共创-参与达人","视频(定金模式)",'抖音短视频合集任务'].includes(item.desc)
              } else if (this.viewType == '直播主页') {
                return ["品牌推广专场（按小时）","品牌推广专场（按天）","电商带货专场","电商带货拼场","明星电商直播"].includes(item.desc)
              }
          })
          res.data.data.price_info = price_info || []
          this.darenPrice = res.data.data
          this.darenPrice.industry_tags = new Set(this.darenPrice.industry_tags.map(x=>x.split('-')[0]))
      }).catch(err => {} )
    },
    async getDrBaseInfo(){
      //   获取达人基础信息
      this.loadingObj.darenInfo = true
      this.$api.getData.getDarenInfo(`/${this.darenID}?platform_channel=${this.viewType == '短视频主页'? 1 : 10}`).then((res) => {
          window.sessionStorage.setItem('getDarenInfo',JSON.stringify(res));


          if(res.data.code===10003){
              this.isAdd=true
          }
          res.data.data.base64_qrcode = 'data:image/png;base64,'+ res.data.data.base64_qrcode
          if(res.data.data.follower>=10000){
              res.data.data.follower=(res.data.data.follower/10000).toFixed(1)+'w'
          }
          if(res.data.data.gender===1){
              res.data.data.gender='男'
          }else{
              res.data.data.gender='女'
          }
          this.darenInfo = res.data.data;

      }).finally(()=>{
          this.loadingObj.darenInfo = false
      })
    }
  },
  created(){
    if(!this.$route.query.id) {
        // this.$message.warning(`该达人未上星图,无法采集星图数据！你可以在本页面查看该达人的基础信息和历史合作信息~`)
        if (this.$store.state.auth.showCooperAnalysis == 1 && this.auth_order_type.length) {
            this.activeName = "合作案例"
        } else {
            this.activeName = '达人概览'
        }
    }
    if (this.$route.query.viewType) {
      this.viewType = this.$route.query.viewType == 'live' ? '直播主页' : '短视频主页'
    }
    this.auth_order_type = JSON.parse(localStorage.getItem('auth_order_type')) || []
    this.hide_fields = JSON.parse(localStorage.getItem("dy_hide_fields")) || []
    this.is_product = localStorage.getItem("gx_is_product") ? JSON.parse(localStorage.getItem('gx_is_product')) : ""
    // this.updateFavorite([])
    // window.updateFavorite = this.updateFavorite

    // 这个接口的数据目前使用 a=talentDetail 接口就可替代
    // this.$axios.get('/api.php?a=talentInLib&m=gx', {
    //     params: {
    //       platid: 1,
    //       starids: this.$route.query.id || '',
    //       shortids: this.$route.query.shortid || '',
    //     },
    //     headers: {
    //      showLoading: false
    //     }
    //   }).then(res => {
    //     if(res.list?.length){
    //       this.hasInStorage = true
    //       this.crmTalentInfo = res.list[0]
    //       this.calendarInfo = {
    //         plat: res.list[0].platform,
    //         shortid: res.list[0].shortid || '',
    //         starid: this.$route.query.id || '',
    //       }
    //     }
    //   })

    if(window.performance.navigation.type===0||window.performance.navigation.type===1||window.performance.navigation.type===2){
        //判断浏览器刷新行为，清除session
        let inSalesGroup=window.sessionStorage.getItem('inSalesGroup')
        let name=window.sessionStorage.getItem('name')
        window.sessionStorage.clear()
        window.sessionStorage.setItem('inSalesGroup',inSalesGroup)
        window.sessionStorage.setItem('name',name)
    }
    this.darenID = this.$route.query.id
    if(this.darenID) {
        this.getLinkStruct()
        this.checkControlFn()
        this.getDrBaseInfo()
        //   获取达人介绍
        this.$api.getData.getDarenDesc('/'+this.darenID).then((res) => {
            this.darenDes.self_intro = res.data?.data?.self_intro;
        })
        this.getPriceData()
    }

    // 获取达人评价 新接口
    this.$axios.get('/api.php?m=index|api|gx&a=talentDetail', {
        params: {
          starid: this.$route.query.id || '',
          shortid: this.$route.query.shortid || '',
        },
        headers: {
          showLoading: false
        }
    }).then(res => {
        // 3个月前的日期节点
        const newSignDateFlag = this.dayjs().subtract(3, 'month')
        // 历史签约号
        res.isHistorySign = res.logings !== '签约号' && res.has_sign == 1
        // 新签约号，当前是签约号，并且签约时间在3个月内
        res.isNewSign = res.logings == '签约号' && newSignDateFlag.isBefore(res.last_sign_time)
        this.authorDrinfo = res
        if(res.mcn==='畅玩文化'){
            this.isChangwanDaren=true
        }
        if(this.authorDrinfo.is_black == 1 || this.authorDrinfo.is_sup_black == 1) {
            let blackType = this.authorDrinfo.is_black == 1 ? '达人已被加入畅玩达人黑名单' : '达人归属供应商被拉黑'
            this.$alert(`
            <div style="display: flex; align-items: center">
                <i class="el-icon-warning" style="font-size: 50px; color: #FF6F28;margin-right: 10px"></i>
                <div>
                    <p>${blackType}，拉黑理由：</p>
                    <p style="font-weight: 600; color: #FF6F28;">${this.authorDrinfo?.black_data?.black_reasons || '-'}</p>
                </div>
            </div>
          `, '提示', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '我知道了'
            });
          }


        this.hasInStorage = true
        res.special_saletype = res.special_saletype?.split(',')?.filter(item => item !== '促销' && item)?.[0]
        this.crmTalentInfo = res
        this.calendarInfo = {
            plat: res.platform,
            shortid: res.shortid || '',
            starid: this.$route.query.id || '',
        }

        if (this.is_product && this.logings == '合作号/野生') {
            this.getSupplierData(this.crmTalentInfo.id)
        }
    })



  },
  mounted() {

  },
  watch: {
    activeName(val){
      if(val === '合作案例'){
        let plat = localStorage.getItem('plat')
        switch(plat){
          case 'dy':
          LA.track('dy_short_video_caseinfo');
          break;
          case 'ks':
          LA.track('ks_short_video_caseinfo');
          break;
          case 'blbl':
          LA.track('bz_short_video_caseinfo');
          break;
        }
        // 合作案例埋点
        let logParams = {
            type: 5,
            plat: 1,
            shortid: this.$route.query.shortid || '',
            starid: this.$route.query.id || ''
        }
        this.$api.setUseLog(logParams)
      }
    },
    viewType(){
      this.getDrBaseInfo()
      this.getPriceData()

    }
  }
}
</script>

<style scoped lang="less">
    //禁用的单选按钮hover颜色
    ::v-deep .el-radio-button.is-disabled .el-radio-button__inner:hover{
      color: #c0c4cc;
    }
    .darenInfoContainer{
        // min-width: 800px;
        // max-width: 1200px;
        margin: 16px auto 40px;
        display: flex;
        justify-content: center;
    }
    .contentLeft{

        // width: 320px;
        // height: 100px;
        width: 360px;

    }



    /* topTitle tab公共样式 start*/

  .darenInfoContainer /deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner{
    color: #FF5C00;
    background-color: #FFF2EB;
    border-color: #FF5C00;
    box-shadow: -1px 0 0 0 #FF5C00;
  }
  .darenInfoContainer /deep/ .el-radio-button__inner:hover{
    color: #333;
  }
  .darenInfoContainer /deep/ .el-radio-button__inner{
    padding: 10px 16px;
  }
  .darenInfoContainer /deep/ .el-radio-button:first-child .el-radio-button__inner{
    border-radius: 2px 0 0 2px;
  }
  .darenInfoContainer /deep/ .el-radio-button:last-child .el-radio-button__inner{
    border-radius: 0
  }

  /* topTitle tab公共样式 end*/


    .contentRight{
        flex: 1;

        max-width: 1310px;
        min-width: 864px;
        /deep/ .el-tabs__header{
          position: sticky;
          top: 0;
          z-index: 90;
        }
    }
    .contentRight /deep/ .el-tabs__active-bar{
        background-color: #FF5C00!important;
    }
    .contentRight /deep/ .el-tabs__item{
        color: #333;
        height: 50px;
        line-height: 50px;
    }
    .contentRight /deep/ .el-tabs__nav-scroll {
        height: 50px;
        padding-left: 24px;
        background: #fff;
        border-radius: 6px;
    }
    .contentRight /deep/ .el-tabs__item.is-active {
        color: #333;
    }
    .contentRight /deep/ .el-tabs__header{
        margin-bottom: 0;
    }
    .contentRight /deep/ .el-tabs__content{
        margin-top: 15px;
    }
    .contentRight /deep/ .el-tabs__nav-wrap::after{
        height: 1px;
        background: #f5f5f5;
    }

    // 改版新增样式
    .block-title{
        line-height: 50px;
        font-size: 14px;
        font-family: OPPOSans;
        font-weight: 500;
        color: #333333;
    }
    .block-wrap,::v-deep .block-wrap {
        background-color: rgba(255, 255, 255, 1);
        box-sizing: border-box;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border-radius: 8px;
    }
    ::v-deep .tab-block-wrap > .el-tabs__header{
        margin: 0 15px;
        background-color: rgba(255, 255, 255, 1);
        box-sizing: border-box;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border-radius: 8px;
    }
    ::v-deep .tab-block-wrap > .el-tabs__content{
        margin-top: 0px;
        // 用padding是为了tab容器内的盒子阴影不被裁切
        padding: 15px 15px;
    }
</style>
